import type { Messages } from '../en'

export const flows: Messages['flows'] = {
  title: 'Fluxos',
  subtitle:
    'Escolha um fluxo para iniciar. Alguns fluxos podem fazer uma pausa para tirar uma dúvida durante a execução.',
  loading: 'Carregando fluxos…',
  emptyState: 'Ainda não há fluxos disponíveis para sua conta. Volte em breve.',
  unavailable: 'Indisponível',
  interactiveBadge: 'Interativo · pode fazer perguntas',
  start: 'Iniciar',
  history: 'Histórico'
}
